import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RefreshProvider } from './contexts/RefreshContext';
import { TaskRefreshProvider } from './contexts/TaskRefreshContext';
import { PhoneProvider } from './contexts/PhoneContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/layout/Layout';
import CallOverlay from './components/ui/CallOverlay';

// Pages
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import TasksPage from './pages/TasksPage';
import BusinessesPage from './pages/BusinessesPage';
import PeoplePage from './pages/PeoplePage';
import ToolsPage from './pages/ToolsPage';
import GoalsPage from './pages/GoalsPage';
import LearningPage from './pages/LearningPage';
import HabitsPage from './pages/HabitsPage';
import EmailsPage from './pages/EmailsPage';
import JournalPage from './pages/JournalPage';
import MoodTrackerPage from './pages/MoodTrackerPage';
import MeetingsPage from './pages/MeetingsPage';
import CalendarPage from './pages/CalendarPage';
import BusinessDetailPage from './pages/BusinessDetailPage';
import GoalDetailPage from './pages/GoalDetailPage';
import PersonDetailPage from './pages/PersonDetailPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import TaskDetailPage from './pages/TaskDetailPage';
import BookDetailPage from './pages/BookDetailPage';
import CourseDetailPage from './pages/CourseDetailPage';
import LessonDetailPage from './pages/LessonDetailPage';
import HabitDetailPage from './pages/HabitDetailPage';
import JournalDetailPage from './pages/JournalDetailPage';
import WishListPage from './pages/WishListPage';
import SettingsPage from './pages/SettingsPage';
import GlossaryPage from './pages/GlossaryPage';
import SearchResultsPage from './pages/SearchResultsPage';
import CronMonitorPage from './pages/CronMonitorPage';
import HomePage from './pages/HomePage';
import HealthPage from './pages/HealthPage';
import HealthGoalsPage from './pages/HealthGoalsPage';
import FinancePage from './pages/FinancePage';
import SprintHistoryPage from './pages/SprintHistoryPage';
import TrackingPage from './pages/TrackingPage';
import ChatPage from './pages/ChatPage';
import ExpectationsPage from './pages/ExpectationsPage';
import DreamsPage from './pages/DreamsPage';
import DreamDetailPage from './pages/DreamDetailPage';
import DocumentsPage from './pages/DocumentsPage';

function App() {
  return (
    <Router>
      <AuthProvider>
      <RefreshProvider>
        <TaskRefreshProvider>
          <PhoneProvider>
            <CallOverlay />
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              
              {/* Protected routes with Layout */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/projects" element={
                <ProtectedRoute>
                  <Layout>
                    <Projects />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/tasks" element={
                <ProtectedRoute>
                  <Layout>
                    <TasksPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/expectations" element={
                <ProtectedRoute>
                  <Layout>
                    <ExpectationsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/businesses" element={
                <ProtectedRoute>
                  <Layout>
                    <BusinessesPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/sprint-history" element={
                <ProtectedRoute>
                  <Layout>
                    <SprintHistoryPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/people" element={
                <ProtectedRoute>
                  <Layout>
                    <PeoplePage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/tools" element={
                <ProtectedRoute>
                  <Layout>
                    <ToolsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/goals" element={
                <ProtectedRoute>
                  <Layout>
                    <GoalsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/learning" element={
                <ProtectedRoute>
                  <Layout>
                    <LearningPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/habits" element={
                <ProtectedRoute>
                  <Layout>
                    <HabitsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/wishlist" element={
                <ProtectedRoute>
                  <Layout>
                    <WishListPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/glossary" element={
                <ProtectedRoute>
                  <Layout>
                    <GlossaryPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/emails" element={
                <ProtectedRoute>
                  <Layout>
                    <EmailsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/meetings" element={
                <ProtectedRoute>
                  <Layout>
                    <MeetingsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/calendar" element={
                <ProtectedRoute>
                  <Layout>
                    <CalendarPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/home" element={
                <ProtectedRoute>
                  <Layout>
                    <HomePage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/journal" element={
                <ProtectedRoute>
                  <Layout>
                    <JournalPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/journal/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <JournalDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/mood-tracker" element={
                <ProtectedRoute>
                  <Layout>
                    <MoodTrackerPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/health" element={
                <ProtectedRoute>
                  <Layout>
                    <HealthPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/health/goals" element={
                <ProtectedRoute>
                  <Layout>
                    <HealthGoalsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/finance" element={
                <ProtectedRoute>
                  <Layout>
                    <FinancePage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/settings" element={
                <ProtectedRoute>
                  <Layout>
                    <SettingsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/cron-monitor" element={
                <ProtectedRoute>
                  <Layout>
                    <CronMonitorPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/search" element={
                <ProtectedRoute>
                  <Layout>
                    <SearchResultsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/chat" element={
                <ProtectedRoute>
                  <Layout>
                    <ChatPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/tracking" element={
                <ProtectedRoute>
                  <Layout>
                    <TrackingPage />
                  </Layout>
                </ProtectedRoute>
              } />

              <Route path="/dreams" element={
                <ProtectedRoute>
                  <Layout>
                    <DreamsPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/dreams/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <DreamDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/documents" element={
                <ProtectedRoute>
                  <Layout>
                    <DocumentsPage />
                  </Layout>
                </ProtectedRoute>
              } />

              {/* Detail pages */}
              <Route path="/businesses/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <BusinessDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/goals/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <GoalDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/people/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <PersonDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/projects/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <ProjectDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/tasks/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <TaskDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/books/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <BookDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/courses/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <CourseDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/lessons/:lessonId" element={
                <ProtectedRoute>
                  <Layout>
                    <LessonDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/lessons/:lessonId/edit" element={
                <ProtectedRoute>
                  <Layout>
                    <LessonDetailPage isEditMode={true} />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/habits/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <HabitDetailPage />
                  </Layout>
                </ProtectedRoute>
              } />
            </Routes>
          </PhoneProvider>
        </TaskRefreshProvider>
      </RefreshProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
